<!-- <div class="modal fade" id="modalViajantes" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content"> -->
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{"Viajantes" | translate}}</h5>
            </div>
            <div class="modal-body" *ngFor="let quarto of quartos; let i = index">
                <div class="container">
                    <div class="room">
                        <h6>{{"Quarto" | translate}} {{ i + 1 }}</h6>
                        <div class="d-flex justify-content-between">
                            <p>{{"Adultos" | translate}}</p>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-minus-circle text-secondary" (click)="quarto.removerAdulto()"></i>
                                <p style="margin: 0 12px;">{{ quarto.qtdeAdultos }}</p>
                                <i class="fas fa-plus-circle text-secondary" (click)="quarto.adicionarAdulto()"></i>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <p>{{"Crianças" | translate}}</p>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-minus-circle text-secondary" (click)="quarto.removerCrianca()"></i>
                                <p style="margin: 0 12px;">{{ quarto.qtdeCriancas }}</p>
                                <i class="fas fa-plus-circle text-secondary" (click)="quarto.adicionarCrianca()"></i>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between"
                            *ngFor="let idadeCriancas of quarto.idadesCriancas; let x = index">
                            <p>{{ "Idade Criança " + (x + 1) | translate }}</p>
                            <div class="d-flex align-items-center">
                                <select class="form-control input-sm" name="idades-{{x}}"
                                    [(ngModel)]="quarto.idadesCriancas[x]">
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary" *ngIf="quartos.length > 1"
                    (click)="decrementaQuartos()">
                    {{ "Remover Quarto" | translate }}
                </button>
                <button type="button" class="btn btn-outline-primary" (click)="incrementaQuartos()">
                    {{ "Adicionar Quarto" | translate }}
                </button>
                <button *ngIf="modal" type="button" class="btn btn-primary" (click)="fecharModal();">
                    Ok
                </button>
            </div>
        <!-- </div>
    </div>
</div> -->